import api from "@/lib/api";

let statusPromise = null;
// One shared request per page for the TikTok connection status (many cards read it).
export function tiktokStatus(force = false) {
  if (!statusPromise || force) statusPromise = api.get("/tiktok/status").then((r) => r.data).catch(() => ({ configured: false, account: null }));
  return statusPromise;
}

// TikTok refuses to render inside an iframe (preview panels) — break out to the top window.
export function openOAuth(url) {
  if (window.self !== window.top) {
    try { window.top.location.href = url; return; } catch { /* cross-origin top */ }
    window.open(url, "_blank", "noopener");
    return;
  }
  window.location.href = url;
}

export async function connectTikTok() {
  const { data } = await api.get("/tiktok/login");
  openOAuth(data.url);
}
